
window.BUNDLES = [
  {
    id: "starter_bundle",
    title: "Starter Coffee Bundle",
    description: "Perfect combo to get you going",
    price: 34.42,
    compareAtPrice: 40.50,
    discountPercent: 15,
    discountCode: "BUNDLE15",
    badge: "Best Value",
    products: [
      {
        title: "Logo Mug 11 oz.",   // 👈 ADD THIS
        variantId: 46668561514654,
        qty: 1,
        image: "https://hellhoundcoffee.myshopify.com/cdn/shop/files/5a6aa92b50a6d6782c8e77e4b564b631.jpg?v=1775190072&width=832"
      },
      {
        title: "Breakfast Blend 1 lb.",   // 👈 ADD THIS
        variantId: 46648009293982,
        qty: 1,
        selling_plan: 3822190750,
        image: "https://hellhoundcoffee.myshopify.com/cdn/shop/files/label5_on_bag_6a29ad94-c0ab-4951-baa2-97554b6ea738.jpg?v=1774581263&width=832"
      }
    ]
  },

  {
    id: "apparel_bundle",
    title: "Apparel Combo Bundle",
    description: "Get The Gear!",
    price: 56.11,
    compareAtPrice: 66.00,
    discountPercent: 15,
    discountCode: "BUNDLE15",
    badge: "Best Value",
    products: [
      {
        title: "White Logo Hat",   // 👈 ADD THIS
        variantId: 46650442252446,
        qty: 1,
        image: "https://hellhoundcoffee.myshopify.com/cdn/shop/files/ninjapod_12498540_f_5001_00_f.jpg?v=1774642465&width=832"
      },
      {
        title: "Deluxe Hoodie",   // 👈 ADD THIS
        variantId: 46661227675806,
        qty: 1,
        image: "https://hellhoundcoffee.myshopify.com/cdn/shop/files/ninjapod_12526501_b_G185_51_b.jpg?v=1775019286&width=832"
      }
    ]
  },

  {
    id: "heavy_bundle",
    title: "Heavy Hitter Bundle",
    description: "For serious coffee drinkers",
    price: 41.41,
    compareAtPrice: 46.00,
    discountPercent: 10,
    discountCode: "BUNDLE10",
    badge: "Best Value",
    products: [
      {
        title: "African Espresso 1 lb.",   // 👈 ADD THIS
        variantId: 46648010047646,
        qty: 1,
        image: "https://hellhoundcoffee.myshopify.com/cdn/shop/files/label5_on_bag_34654eb0-3461-4b1c-8417-ed123af730b5.jpg?v=1774549306&width=1200"
      },
      {
        title: "Kopi Safari 1 lb.",   // 👈 ADD THIS
        variantId: 46648695849118,
        qty: 1,
        image: "https://hellhoundcoffee.myshopify.com/cdn/shop/files/label5_on_bag_6a29ad94-c0ab-4951-baa2-97554b6ea738.jpg?v=1774581263&width=1200"
      }
    ]
  }
];